import _ from "lodash";
import React, { useLayoutEffect } from "react";

import { useDispatch } from "react-redux";

import useRouteConfig from "@src/hooks/useRouteConfig";

import { routeEnter, routeExit } from "../containers/App/App.slice";


function RouteDispatcher({ children }: { children: React.ReactNode }) {

  const dispatch = useDispatch();
  const routeItem = useRouteConfig();

  useLayoutEffect(() => {
    if (routeItem) {
      dispatch(routeEnter(routeItem));
      document.body.classList.add(`page-${routeItem?.slug}`);
      document.title = routeItem?.title ? `myKredit | ${routeItem.title}` : "myKredit";
    }

    return () => {
      if (routeItem) {
        dispatch(routeExit(routeItem));
        document.body.classList.remove(`page-${routeItem?.slug}`);
      }
    };
  }, [ routeItem, dispatch ]);

  return (
    <>{children}</>
  );
}


export default RouteDispatcher;
